var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-startPractice" },
    [
      _c(
        "div",
        { staticClass: "leftBox", attrs: { id: "leftBox" } },
        [
          _c("div", [
            _c(
              "div",
              { class: _vm.titleScroll },
              [
                _c("i", {
                  staticClass: "iconfont iconfanhui",
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                }),
                _vm._l(_vm.otherInfoDTO.title, function (item, index) {
                  return _c("span", { key: index }, [
                    _vm._v(" " + _vm._s(item) + " "),
                    _vm.otherInfoDTO.title.length - 1 !== index
                      ? _c("em")
                      : _vm._e(),
                  ])
                }),
              ],
              2
            ),
          ]),
          _vm._l(_vm.topicLists, function (itemTo, indexTo) {
            return _c(
              "div",
              {
                key: indexTo,
                staticClass: "topicDivButton",
                class: _vm.fontClass,
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "topicDiv",
                    attrs: {
                      id: itemTo.question_style != 6 && `id_${itemTo.sort}`,
                    },
                  },
                  [
                    itemTo.question_style === 1
                      ? _c("ChoiceOne", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 2
                      ? _c("Judge", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 3
                      ? _c("ChoiceMultiple", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 4
                      ? _c("FillBlank", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 5
                      ? _c("Subjective", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 6
                      ? _c(
                          "div",
                          [
                            _c("div", {
                              staticClass: "questionAskTitle",
                              attrs: { id: "questionAskTitle" },
                              domProps: { innerHTML: _vm._s(itemTo.content) },
                            }),
                            itemTo.audio_url
                              ? _c(
                                  "div",
                                  { staticClass: "audioDiv" },
                                  _vm._l(
                                    itemTo.audio_url.split(","),
                                    function (itemAudio, indexAudio) {
                                      return _c(
                                        "audio",
                                        {
                                          key: indexAudio,
                                          staticClass: "sourceAudio",
                                          attrs: { controls: "controls" },
                                        },
                                        [
                                          _c("source", {
                                            attrs: {
                                              src: itemAudio,
                                              type: "audio/ogg",
                                            },
                                          }),
                                          _vm._v(
                                            " Your browser does not support the audio element. "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _vm._l(itemTo.child, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  attrs: { id: `id_${item.sort}` },
                                },
                                [
                                  item.question_style === 1
                                    ? _c("ChoiceOne", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 4
                                    ? _c("FillBlank", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 2
                                    ? _c("Judge", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 3
                                    ? _c("ChoiceMultiple", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 5
                                    ? _c("Subjective", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "mat20", staticStyle: { "min-height": "inherit" } },
        [
          _c("AnswerSheet", {
            attrs: { datas: _vm.topicCard, total: _vm.total },
            on: { change: _vm.jumpTo, submit: _vm.submit },
          }),
        ],
        1
      ),
      _c("ComponentDialog1", {
        attrs: {
          icon: _vm.scoreDialog.icon,
          title: _vm.scoreDialog.title,
          score: _vm.scoreDialog.score,
          visible: _vm.isScoreVisible,
          iconPosition: "left-top",
          showCancelBtn: _vm.scoreDialog.showCancelBtn,
          cancelText: "重做",
          confirmText: "查看解析",
        },
        on: {
          "update:visible": function ($event) {
            _vm.isScoreVisible = $event
          },
          cancel: _vm.clearCourse,
          confirm: _vm.scoreConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }